import { observer } from 'mobx-react-lite'
import { type DocumentRequestedSupportingItemViewModel } from '../../DocumentRequestedSupportingItemViewModel'
import { WizardContentBody, WizardContentFooter } from '@/components/Wizard'
import { TaxInfoGatheringWizardContentButtonGroupContainer } from '../../../components/TaxInfoGatheringWizardContentButtonGroupContainer'
import { type TaxInfoGatheringViewModel } from '../../../TaxInfoGatheringViewModel'
import { RequestedDocumentCardContainer } from '../RequestedDocumentCard/RequestedDocumentCardContainer'
import { RequestedDocumentFootnote } from '@/features/jobs/details/tax-type/info-gathering/documents/components/RequestedDocumentCard'

interface DocumentWizardContentContainerProps {
  itemVm: DocumentRequestedSupportingItemViewModel
  taxInfoGatheringVm: TaxInfoGatheringViewModel
}

export const DocumentWizardContentContainer = observer(
  function DocumentWizardContentContainer({
    itemVm,
    taxInfoGatheringVm,
  }: DocumentWizardContentContainerProps) {
    const isSkeleton = itemVm.fetch.pending
    const isCompleteInfoGatheringPending =
      taxInfoGatheringVm.confirmCompleteInfoGathering.pending

    return (
      <>
        <WizardContentBody>
          <RequestedDocumentCardContainer
            variant="decorative"
            vm={itemVm}
            isDisabled={isCompleteInfoGatheringPending}
          />
          <RequestedDocumentFootnote />
        </WizardContentBody>
        <WizardContentFooter>
          <TaxInfoGatheringWizardContentButtonGroupContainer
            isSkeleton={isSkeleton}
            variant="nav-only"
            taxInfoGatheringVm={taxInfoGatheringVm}
            itemVm={itemVm}
          />
        </WizardContentFooter>
      </>
    )
  },
)
